export const useStyles = (theme) => ({
    quillStyle: {
        height: 250,
        marginBottom: 15
    }
})
